var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{attrs:{"color":_vm.dateType == 0 ? 'volcano' : _vm.dateType == 2 ? 'green' : 'geekblue'}},[_vm._v(_vm._s(_vm.dateType == 0 ? '未知' : _vm.dateType == 1 ? '工作日（上班）' : '节假日（休息）'))])
}
var staticRenderFns = []

export { render, staticRenderFns }